import { usePermissions } from 'features/permissions/usePermissions';
import { useFeatureFlag } from 'features/feature-set/useFeatureFlag';
import { PermissionTypes } from 'features/permissions/types';
import { useBreakoutRooms } from 'features/breakout-rooms/useBreakoutRooms';
import { useAppSelector } from 'store/hooks';
import {
  selectBreakoutRoomFreeMovement,
  selectBreakoutRoomsStatus,
} from 'features/breakout-rooms/breakoutRoomsSlice';
import { canAccessParticipants } from 'features/users/canAccessParticipants';
import { useSystemSession } from 'hooks/useSystemSession';

export const useParticipants = () => {
  const { hasPermissions } = usePermissions();
  const isSystemSession = useSystemSession();
  const isFeatureEnabled = useFeatureFlag('participantsList');
  const breakoutRoomsEnabled = useFeatureFlag('breakoutRooms');

  const canSeeParticipantsPanel = hasPermissions(PermissionTypes.seeParticipantsPanel);
  const canManageBreakout = hasPermissions(PermissionTypes.manageBreakout);
  const breakoutStatus = useAppSelector(selectBreakoutRoomsStatus);
  const breakoutFreeMovement = useAppSelector(selectBreakoutRoomFreeMovement);

  const { breakoutsFreeMovementAvailable } = useBreakoutRooms();

  const isFeatureAvailable = canAccessParticipants({
    participantsListEnabled: isFeatureEnabled,
    canSeeParticipantsPanel,
    breakoutRoomsEnabled,
    canManageBreakout,
    breakoutStatus,
    breakoutFreeMovement,
    isSystemSession,
  });

  return {
    isFeatureAvailable,
    canSeeParticipantsPanel,
    breakoutsFreeMovementAvailable,
  };
};
